<template>
  <div class="section-fullscreen">
    <div class="container">
      <div class="position-middle">
        <div class="row">
          <div class="col-12 col-md-10 coffset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
            <h1 class="display-1 font-weight-bold">404</h1>
            <h5 class="font-weight-light text-black-05">
              <!-- Sorry, It appears that the page you were looking for
              doesn't exist or might have been moved. -->
              Sorry, de pagina die je zoekt kon niet worden gevonden.
            </h5>
            <router-link to="/" class="button button-xl button-radius margin-top-30"> <!-- button-reveal-left-grey -->
              <!-- <font-awesome-icon :icon="['fas', 'home']" /> -->
              <span>Keer terug naar de voorpagina</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>